import { Seo } from '@/components/site/seo';
import { HeroSection } from '@/components/site/sections/hero';
import { ManifestoSection } from '@/components/site/sections/manifesto';
import { ServicesSection } from '@/components/site/sections/services';
import { TeamSection } from '@/components/site/sections/team';
import { NewsSection } from '@/components/site/sections/news';
import { FaqsSection } from '@/components/site/sections/faqs';
import { ContactSection } from '@/components/site/sections/contact';
import { listFaqs, listNews, listServices, listTeam } from '@/lib/data/public';
import { useLiveData } from '~/hooks/useLiveData';
import { useLocaleContext } from '~/hooks/useLocaleContext';

export default function HomePage() {
  const { locale, dict, settings } = useLocaleContext();
  const services = useLiveData(listServices, [locale]).data ?? [];
  const team = useLiveData(listTeam, [locale]).data ?? [];
  const news = useLiveData(() => listNews(3), [locale]).data ?? [];
  const faqs = useLiveData(listFaqs, [locale]).data ?? [];

  return (
    <>
      <Seo locale={locale} title={dict.hero.title} description={dict.hero.subtitle} />
      <HeroSection locale={locale} dict={dict} settings={settings} />
      <ManifestoSection dict={dict} />
      <ServicesSection locale={locale} dict={dict} services={services} />
      <TeamSection locale={locale} dict={dict} team={team} />
      <NewsSection locale={locale} dict={dict} news={news} />
      <FaqsSection locale={locale} dict={dict} faqs={faqs} />
      <ContactSection locale={locale} dict={dict} settings={settings} />
    </>
  );
}
